import { ChatTransport } from "@/types";
import { createPollingTransport } from "./pollingTransport";

/**
 * Factory for the live-chat transport.
 *
 * Currently always returns a polling transport. A future push-based transport
 * (WebSocket / Firebase) can be selected here without touching the session
 * store, which only depends on the `ChatTransport` interface.
 */
export function createTransport(options?: {
  intervalMs?: number;
}): ChatTransport {
  return createPollingTransport(options);
}

export { createPollingTransport };
